import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Spinner } from "react-bootstrap";
import "./_assignment.scss"
import moment from "moment";
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import StudentDetailsModal from './StudentDetailsModal';



class AssignmentStudentDetailsHome extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      blockType: "1",
      viewDetailsModal: false,
      creationDetailsModal: false,
      individualStudentData: [],
      loadingSpinner: 0,
      currentStep: 1,
      submitError: "",
      seenUnseenId: 0,
      count: 0,
    }
  }

  articlecolumns3 = [
    {
      dataField: "student_name",
      text: "Student Name",
      // attrs:{width:50,className:"student_names"}
    },

    {
      dataField: "roll_no",
      text: "Roll No.",
    },

    {
      dataField: "submitted_date",
      text: "Submitted Date",
    },

    {
      dataField: 'View Details',
      formatter: this.PerformanceFunc.bind(this),
      text: 'View Details',
    },
  ];

  articlecolumns1 = [
    {
      dataField: "student_name",
      text: "Student Name",
    },
    {
      dataField: "roll_no",
      text: "Roll No.",
    },
  ];

  articlecolumns2 = [
    {
      dataField: "student_name",
      text: "Student Name",
    },
    {
      dataField: "roll_no",
      text: "Roll No.",
    },
    {
      dataField: "viewed_date",
      text: "Assignment Viewed Date",
    },

  ];

  tableData1(data) {
    let returnData = data.map((item) => {
      return {
        student_name: item.student_name,
        roll_no: item.roll_no,
      };
    });
    return returnData;
  }

  tableData2(data) {
    console.log(data, "oooooooo")
    let returnData = data.map((item) => {
      return {
        student_name: item.student_name,
        roll_no: item.roll_no,
        viewed_date: moment.unix(item.timestamp).format("DD-MM-YYYY"),
    };
    });
    return returnData;
  }

  PerformanceFunc(val, row) {
    console.log(row, "qqqqqqq")
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ viewDetailsModal: true, individualStudentData: row.individualStudentData })}>
        <Button variant="link" name="view" className="text-theme">
          <i className="fas fa-eye" />
        </Button>
        <span>
            {
              row.individualStudentData.marks !== null && row.individualStudentData.verifier_comments !== "" ?("(Verified)"):""
            }
          </span>
      </div>
    );
  };


  tableData3(data) {
    console.log(data, "dataing")
    let returnData = [];
    data.sort((a, b) => {
      const aIsEmpty = a.marks !== "" && a.verifier_comments !== "";
      const bIsEmpty = b.marks !== "" && b.verifier_comments !== "";
      
      if (aIsEmpty && !bIsEmpty) {
          return 1;
      } else if (!aIsEmpty && bIsEmpty) {
          return -1;
      } else {
          return 0;
      }
  });
    data.map((item) => {
      const newObj = {
        student_name: item.student_name,
        roll_no: item.roll_no,
        submitted_date: moment.unix(item.submitted_time).format("DD-MM-YYYY"),
        marks: item.marks,
        verifier_comments: item.verifier_comments,
        individualStudentData: item
      }
      returnData.push(newObj);

    })
    return returnData;

  }

  render() {
    console.log(this.state, "helloooooooooooo")

    const studentData = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusSubmitData
    console.log("studentData", studentData);

    let studentFilterData = []
    let notSeenStudents = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusNotSeenData.length
    let seenStudents = 0
    let completedStudents = 0

    if(studentData !==  undefined){
      if (this.state.blockType == "2") {
        studentFilterData = studentData.filter((item) => item.status == "1")
      }
      else if (this.state.blockType == "3") {
        studentFilterData = studentData.filter((item) => item.status == "2")
      }

    notSeenStudents = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusNotSeenData.length
    seenStudents = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusSubmitData.filter((item) => item.status == "1").length
    completedStudents = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusSubmitData.filter((item) => item.status == "2").length
  }else{
     notSeenStudents = this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusNotSeenData.length
     seenStudents = 0
     completedStudents = 0
  }

    return (
      <section className='student-details'>
        <Container>
          <Row className="mt-2">
            <Col xl={12} lg={12} md={12} sm={12}>
              <div className="pb-1 my-2 d-flex align-items-center justify-content-between">
                <h2 className="title h5 mb-0">Student Status Details</h2>
              </div>
            </Col>
            <Col sm={12}>
              <Card className="border-0 shadow-sm mb-4 ">

                <Card.Header>

                  <Container fluid className='studentDetails'>
                    <Row>
                      <Col sm={4} className='mt-3 mb-3'>
                        <Card className={this.state.blockType == "1" ? "active block_view" : "block_view"} onClick={() => this.setState({ blockType: "1" })}>
                          <Card.Body>
                            <h5 className="text-center"><span className='title_alignment'>Not Seen <i className="fas fa-eye-slash text-success" />{notSeenStudents}</span></h5>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col sm={4} className='mt-3 mb-3'>
                        <Card className={this.state.blockType == "2" ? "active block_view" : "block_view"} onClick={() => this.setState({ blockType: "2" })}>
                          <Card.Body>
                            <h5 className="text-center"><span className='title_alignment'>Assignment Viewed <i className="fas fa-eye text-success" />{seenStudents}</span></h5>
                          </Card.Body>
                        </Card>

                      </Col>
                      <Col sm={4} className='mt-3 mb-3'>
                        <Card className={this.state.blockType == "3" ? "active block_view" : "block_view"} onClick={() => this.setState({ blockType: "3" })}>
                          <Card.Body>
                            <h5 className="text-center"><span className='title_alignment'>Assignment Completed <i className="fas fa-check-circle text-success" />{completedStudents}</span></h5>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body>
                  
                  {
                    
                    this.state.blockType == "1" ?

                      (
                        <div>
                          {this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusNotSeenData.length > 0 ? (
                            <CardLessDataTableWithSearch
                              parentData={this.tableData1(this.props.getStudentDairyAssignmentDetails.getStudentDairyAssignmentDetails.statusNotSeenData)}
                              particlecolumns={this.articlecolumns1}
                              name="attendance"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )
                      : this.state.blockType == "2" ?
                        (
                          <div>
                            {
                              studentFilterData.length > 0 ?
                                (
                                  <CardLessDataTableWithSearch
                                    parentData={this.tableData2(studentFilterData)}
                                    particlecolumns={this.articlecolumns2}
                                    name="attendance"
                                  />
                                ) : (
                                  <Col ls={12} md={12} sm={12}>
                                    <h4 className='mt-3 text-center'><span className="text-danger"></span> No data available</h4>
                                  </Col>
                                )
                            }
                          </div>
                        )
                        :
                        this.state.blockType == "3" ?
                          studentFilterData.length > 0 ? (

                            <CardLessDataTableWithSearch
                              parentData={this.tableData3(studentFilterData)}
                              particlecolumns={this.articlecolumns3}
                              name="attendance"
                            />
                            
                          ) : (
                            <Col ls={12} md={12} sm={12}>
                              <h4 className='mt-3 text-center'><span className="text-danger"></span> No data available</h4>
                            </Col>
                          )
                          : ""
                  }
                  
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <StudentDetailsModal
            stateData={this.state}
            show={this.state.viewDetailsModal}
            onHide={() => this.setState({ viewDetailsModal: false })}
            getStudentDairyAssignmentDetails={this.props.getStudentDairyAssignmentDetails}
          />
        </Container>

      </section>
    )
  }
}

export default AssignmentStudentDetailsHome